import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ToastNotificationService } from '../../../services/toast-notification.service';
import { UserService } from '../../../services/user.service';
import { findFirstNonEmptyString } from '../../../utils';
import { merge } from 'rxjs';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'frmg-invite-modal',
  templateUrl: './invite-modal.component.html',
  styleUrls: ['./invite-modal.component.scss'],
  imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatSelect, MatOption, MatButton, MatDialogClose]
})
export class InviteModalComponent implements OnInit {
  public newUserGroup: FormGroup;
  public roles: Array<string> = ['admin', 'member'];
  public isLoading = false;
  errorMessage = signal('');
  constructor(
    private dialogRef: MatDialogRef<InviteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private toastNotificationService: ToastNotificationService,
    private userService: UserService
  ) {
    this.newUserGroup = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      role: ['member', [Validators.required]]
    });

    merge(this.newUserGroup.get('email').statusChanges, this.newUserGroup.get('email').valueChanges)
      .subscribe(() => {
        this.updateErrorMessage();
      });
  }

  ngOnInit(): void {

  }

  updateErrorMessage() {
    if (this.newUserGroup?.get('email').hasError('required')) {
      this.errorMessage.set('You must enter a value');
    } else if (this.newUserGroup?.get('email').hasError('pattern')) {
      this.errorMessage.set('Not a valid email');
    } else {
      this.errorMessage.set('');
    }
  }

  onBlur(): void {
    this.newUserGroup?.get('email').markAsTouched();
    this.newUserGroup?.get('email').updateValueAndValidity();
  }

  public closeDialog(result?: any): void {
    this.dialogRef.close(result);
  }

  public sendInvite(): void {
    this.isLoading = true;
    const userData = localStorage.getItem('user');
    const user = JSON.parse(userData);
    if (user.teams && user.teams.length > 0) {
      this.userService.sendInvite().subscribe(_ => {
        this.isLoading = false;
        this.toastNotificationService.showNotification({ type: 'success', message: 'Invite sent successfully' });
        this.closeDialog(true);
      }, error => {
        this.isLoading = false;
        let errorMsg = 'An error occurred while sending the invite.';
        if (error.status === 400) {
          errorMsg = 'Invalid email address.';
        }
        this.toastNotificationService.showNotification({ type: 'error', message: findFirstNonEmptyString(error.error) || errorMsg });
      });
    }
  }
}
